import {
  faInfoCircle,
  faLocationDot,
  faBriefcase,
  faChartLine,
  faMoneyBill,
  faUser,
  faMapMarkerAlt,
  faCreditCard,
  faHeartPulse
} from '@fortawesome/free-solid-svg-icons'

export const CLINIC_FORM_CATEGORY_ICONS = {
  BASIC_INFORMATION: faInfoCircle,
  LOCATION_AND_CONTACT: faLocationDot,
  PRACTICE_DETAILS: faBriefcase,
  // CGM_INTEGRATION: faChartLine, // Disabled - not currently used
  BILLING_PROFILE: faCreditCard,
  BILLING_MACROS: faMoneyBill,
  SERVICES_OFFERED: faHeartPulse
}

export const CLINIC_FORM_CATEGORY_COLORS = {
  BASIC_INFORMATION: '#1890ff', // Bright blue for basic info
  LOCATION_AND_CONTACT: '#f5222d', // Red for location/contact
  PRACTICE_DETAILS: '#722ed1', // Purple for practice details
  // CGM_INTEGRATION: '#fa8c16', // Orange for integration - Disabled
  BILLING_PROFILE: '#fa8c16', // Orange for billing profile
  BILLING_MACROS: '#52c41a', // Green for billing
  SERVICES_OFFERED: '#eb2f96' // Pink for services offered
}

export const CLINIC_FORM_CATEGORY_LABELS = {
  BASIC_INFORMATION: 'Basic Information',
  LOCATION_AND_CONTACT: 'Location & Contact',
  PRACTICE_DETAILS: 'Practice Details',
  // CGM_INTEGRATION: 'CGM Integration', // Disabled - not currently used
  BILLING_PROFILE: 'Billing Profile',
  BILLING_MACROS: 'Billing Macros',
  SERVICES_OFFERED: 'Services Offered'
}
